module.exports = __webpack_public_path__ + "media/packs/images/partners/partner9-8f0e1710ac43a419d0239adeb440f60d.jpg";